import React, { useState } from 'react';
import { Article, Title } from './Accordion.styles';
import { AccordionItem } from './components/AccordionItem/AccordionItem';

type AccordionProps = {
	items: any[];
	title?: string;
};
export const Accordion = ({ items, title }: AccordionProps) => {
	const [activeItems, setActiveItems] = useState<string[]>([]);

	const handleToggle = (id: string) => {
		if (activeItems.includes(id)) {
			setActiveItems(activeItems.filter((item) => item !== id));
		} else {
			setActiveItems([...activeItems, id]);
		}
	};

	return (
		<Article>
			{title && <Title>{title}</Title>}
			{items.map((item, index) => {
				return (
					<AccordionItem
						key={index}
						activeItems={activeItems}
						handleToggle={handleToggle}
						item={item}
					/>
				);
			})}
		</Article>
	);
};
